<template>
  <div style="overflow: scroll; height: calc(100vh - 75px);">
    <Container>
      <div style="display: flex; flex-direction: row; margin-top: 4rem;"
           :style="{justifyContent: mode === 'edit' ? 'space-between' : 'flex-end'}">
        <div style="display: flex; flex-direction: column" v-if="mode === 'edit'">
          <h1 v-if="currentPolicy && policyLabel">{{ policyLabel }} Editor</h1>
          <p>Last Updated: {{ moment(lastUpdated).format('MMM Do Y') }}</p>
          <span style="font-size: 12px;color: orange;">Note: Please include your own {{ policyLabel }} Title and last updated in your content</span>
        </div>
        <div v-if="isOwner || isMember">
          <DsButton
            :variant="mode === 'view' ? 'rounded' : 'rounded-secondary'"
            label="View mode"
            size="small"
            @click="mode = 'view'"
          />
          <DsButton
            :variant="mode === 'edit' ? 'rounded' : 'rounded-secondary'"
            label="Edit mode"
            size="small"
            @click="mode = 'edit'"
          />
        </div>
      </div>
      <RichTextArea v-if="(isOwner || isMember) && mode === 'edit'" :model-value="html" v-model="html" class="policy-editor" is-simplified :full-height="true"/>
      <div style="display: flex; flex-direction: row; justify-content: flex-end;" v-if="(isOwner || isMember) && mode === 'edit'">
        <DsButton
          style="margin-top: 0.5rem; margin-bottom: 1rem;"
          label="Update"
          :loading="updatingPolicyPage"
          variant="rounded"
          @click="updatePolicyPage"
        />
      </div>
      <div v-if="html && mode === 'view'">
        <div v-html="html" style="margin-bottom: 2rem; margin-top: 2rem"></div>
      </div>
    </Container>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { Policy } from '@/Domain/Policy/Enums/enums'
  import { fetchPolicyPage, updatePolicyPage } from '@/Domain/Policy/Api/policies'
  import Container from '@/components/Container/Container.vue'
  import RichTextArea from '@/components/TextArea/RichTextArea.vue'
  import UserMixin from '@/util/UserMixin'
  import moment from 'moment'

  export default defineComponent({
    name: "Policy",
    mixins: [UserMixin],
    components: { RichTextArea, Container },
    data() {
      return {
        html: '',
        updatingPolicyPage: false,
        mode: 'view',
        lastUpdated: '',
      }
    },
    computed: {
      moment() {
        return moment
      },
      isTermsOfUse() {
        return this.$route.name === Policy.termsOfUse
      },
      isPrivacyPolicy() {
        return this.$route.name === Policy.privacyPolicy
      },
      isCookiePolicy() {
        return this.$route.name === Policy.cookiePolicy
      },
      currentPolicy(): Policy | undefined {
        return (Object.values(Policy) as string[]).includes(this.$route.name)
          ? (this.$route.name as Policy)
          : undefined;
      },
      policyLabel() {
        switch (this.$route.name) {
          case Policy.termsOfUse:
            return 'Terms Of Use'
          case Policy.privacyPolicy:
            return 'Privacy Policy'
          case Policy.cookiePolicy:
            return 'Cookie Policy'
          case Policy.about:
            return 'About'
          default:
            return ''
        }
      }
    },
    methods: {
      fetchPolicyPage() {
        if (this.currentPolicy) {
          fetchPolicyPage(this.currentPolicy)
            .then((response) => {
              this.lastUpdated = response.updatedAt
              this.html = response.value
            })
        }
      },
      updatePolicyPage() {
        this.updatingPolicyPage = true
        updatePolicyPage(this.currentPolicy, { data: this.html })
          .then((response) => {
            this.fetchPolicyPage()
            this.mode = 'view'
          })
          .finally(() => {
            this.updatingPolicyPage = false
          })
      }
    },
    mounted() {
      this.fetchPolicyPage()

      if (this.$route.query && this.$route.query.edit) {
        if (this.isOwner || this.isMember) {
          this.mode = 'edit'
        }
      }

    },
    watch: {
      currentPolicy() {
        this.fetchPolicyPage()
      }
    }
  })
</script>
<style scoped lang="scss">
  .policy-editor {
    margin-top: 3rem;
  }
</style>
